var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"height":"100%"}},[_c('marking-assessment-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }